/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import AutoLogin from '@/middleware/autoLogin.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      beforeEnter: AutoLogin,
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./views/pages/home/ShortcutDashboard.vue')
        },
        {
          path: '/pages/reporting',
          name: 'report',
          component: () => import('./views/pages/reporting-graph/ChartHome.vue')
        },
        {
          path: '/charts-test',
          name: 'chart',
          component: () => import('./views/pages/reporting-graph/ChartHome.vue')
        },
        {
          path: '/pages/traceability-audit',
          name: 'traceability-report-table',
          component: () => import('./views/pages/traceability-audit/TraceabilityAudit')
        },
        {
          path: '/pages/mass-balance-audit',
          name: 'mass-balance-report-table',
          component: () => import('./views/pages/traceability-audit/MassBalanceAudit')
        },
        {
          path: '/pages/sundry-mass-balance-audit',
          name: 'sundry-mass-balance-report-table',
          component: () => import('./views/pages/traceability-audit/SundryMassBalanceAudit')
        },
        {
          path: '/pages/supplier-accreditation-report',
          name: 'supplier-accreditation-report',
          component: () => import('./views/pages/traceability-audit/SupplierAccreditationExpireReport')
        },
        {
          path: '/pages/taste-panels',
          name: 'Form Tests',
          component: () => import('./views/pages/TastePanel/FormTests.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Taste Panels', active: true }
            ],
            pageTitle: 'Taste Panel',
            rule: 'editor'
          }
        },
        {
          path: '/pages/triangle-tests',
          name: 'Triangle Tests',
          component: () => import('./views/pages/TastePanel/TriangleTests.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Triangle Tests', active: true }
            ],
            pageTitle: 'Triangle Tests',
            rule: 'editor'
          }
        },
        {
          path: '/page2',
          name: 'page-2',
          component: () => import('./views/Page2.vue')
        },
        {
          path: '/pages/user-settings',
          name: 'page-user-settings',
          component: () => import('@/views/pages/user-settings/UserSettings.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'User Settings', active: true }
            ],
            pageTitle: 'Settings',
            rule: 'editor'
          }
        },
        {
          path: '/pages/manage-nimble/users',
          name: 'manage-nimble',
          component: () => import('@/views/pages/manage-nimble/ManageNimbleUsers.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Manage Nimble', active: true }
            ],
            pageTitle: 'Manage Nimble',
            rule: 'editor'
          }
        },
        {
          path: '/pages/manage-nimble/suppliers',
          component: () => import('@/views/pages/supplier-manage/SupplierHome.vue'),
          children: [
            {
              path: '',
              name: 'manage-suppliers',
              component: () => import('@/views/pages/supplier-manage/ManageSuppliersTabView.vue'),
              meta: {
                parent: 'manage-suppliers',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Manage Suppliers', active: true }
                ],
                pageTitle: 'Manage Suppliers',
                rule: 'editor'
              }
            },
            {
              path: 'sundry/:id',
              name: 'manage-sundry-suppliers',
              component: () => import('@/views/pages/supplier-manage/sundry-suppliers/SundrySupplierDetailsTabs.vue'),
              meta: {
                parent: 'manage-suppliers',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Manage Suppliers', url: '/pages/manage-nimble/suppliers?step=2' },
                  { title: 'Manage Sundry Suppliers', active: true }
                ],
                pageTitle: 'Manage Sundry Suppliers',
                rule: 'editor'
              }
            },
            {
              path: 'courier-supplier/:id',
              name: 'manage-courier-suppliers',
              component: () => import('@/views/pages/supplier-manage/couriers/CourierSupplierDetailsTabs.vue'),
              meta: {
                parent: 'manage-suppliers',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Manage Suppliers', url: '/pages/manage-nimble/suppliers?step=3' },
                  { title: 'Manage Courier Suppliers', active: true }
                ],
                pageTitle: 'Manage Courier Suppliers',
                rule: 'editor'
              }
            },
            {
              path: 'other-supplier/:id',
              name: 'manage-other-suppliers',
              component: () => import('@/views/pages/supplier-manage/other-suppliers/OtherSupplierDetailsTabs.vue'),
              meta: {
                parent: 'manage-suppliers',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Manage Suppliers', url: '/pages/manage-nimble/suppliers?step=4' },
                  { title: 'Manage Other Suppliers', active: true }
                ],
                pageTitle: 'Manage Other Suppliers',
                rule: 'editor'
              }
            },
            {
              path: ':id',
              name: 'manage-supplier_details',
              component: () => import('@/views/pages/supplier-manage//SupplierDetailsGeneral/SupplierDetailsTabs.vue'),
              meta: {
                parent: 'manage-suppliers',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Manage Suppliers', url: '/pages/manage-nimble/suppliers?step=1' },
                  { title: 'Details', active: true }
                ],
                pageTitle: 'Supplier Details',
                rule: 'editor'
              }
            },
            {
              path: ':supplierId/manufacturing/:id',
              name: 'manage-manufacturing',
              component: () => import('@/views/pages/supplier-manage/SupplierDetailsGeneral/manage-manufacturing/ManufactureDetailsView.vue'),
              meta: {
                parent: 'manage-suppliers',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Manage Suppliers', url: '/pages/manage-nimble/suppliers' },
                  { title: 'Sites', active: true,  }
                ],
                pageTitle: 'Supplier Sites',
                rule: 'editor'
              }
            },
            {
              path: ':supplierId/raw-material/:id',
              name: 'manage-raw-material',
              component: () => import('@/views/pages/supplier-manage/SupplierDetailsGeneral/manage-raw-materials/ManufactureDetailsView.vue'),
              meta: {
                parent: 'manage-suppliers',

                pageTitle: 'Manage Raw Material',
                rule: 'editor'
              }
            },
          ]
        },
        {
          path: '/pages/manage-nimble/customers',
          component: () => import('@/views/pages/customer-manage/CustomerHome.vue'),
          children: [
            {
              path: '',
              name: 'manage-customers',
              component: () => import('@/views/pages/customer-manage/CustomerList.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Manage Customers', active: true }
                ],
                pageTitle: 'Manage Customers',
                rule: 'editor'
              }
            },
            {
              path: 'potential/:id',
              name: 'manage-potential-customer_details',
              component: () => import('@/views/pages/customer-manage/PotentialCustomerDetailsGeneral/PotentialCustomerDetailsTabs.vue'),
              meta: {
                parent: 'manage-customers',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Manage Potential Customers', url: '/pages/manage-nimble/customers?step=1' },
                  { title: 'Details', active: true }
                ],
                pageTitle: 'Potential Customer Details',
                rule: 'editor'
              }
            },
            {
              path: ':id',
              name: 'manage-customer_details',
              component: () => import('@/views/pages/customer-manage/CustomerDetailsGeneral/CustomerDetailsTabs.vue'),
              meta: {
                parent: 'manage-customers',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Manage Customers', url: '/pages/manage-nimble/customers' },
                  { title: 'Details', active: true }
                ],
                pageTitle: 'Customer Details',
                rule: 'editor'
              }
            }
          ]
        },
        {
          path: '/pages/formulations',
          name: 'manage-formulation',
          component: () => import('@/views/pages/formulations/FormulationList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Formulations & NPD', active: true }
            ],
            pageTitle: 'Manage Formulations',
            rule: 'editor'
          }
        },
        {
          path: '/pages/formulations/:id',
          name: 'formulation-view',
          component: () => import('@/views/pages/formulations/FormulationGeneral.vue'),
          meta: {
            parent: 'manage-formulation',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Formulations & NPD', url: '/pages/formulations'},
              { title: 'Details', active: true }
            ],
            pageTitle: 'Manage Formulations',
            rule: 'editor'
          }
        },
        {
          path: '/pages/formulations/:id/sample',
          name: 'formulation-view',
          component: () => import('@/views/pages/formulations/sample-play/FormulationItemSamplePlay.vue'),
          meta: {
            parent: 'manage-formulation',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Formulations & NPD', url: '/pages/formulations'},
              { title: 'Sample Exercise', active: true }
            ],
            pageTitle: 'Manage Formulations',
            rule: 'editor'
          }
        },
        {
          path: '/pages/raw-materials',
          name: 'raw-material-manage',
          component: () => import('@/views/pages/raw-material/RawMaterialHome.vue'),
          children: [
            {
              path: '',
              name: 'manage-raw-materials',
              component: () => import('@/views/pages/raw-material/RawMaterialTabView.vue'),
              meta: {
                parent: 'raw-material-manage',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Raw materials', active: true }
                ],
                pageTitle: 'Manage Raw Material',
                rule: 'editor'
              }
            },
            {
              path: ':id',
              name: 'view-raw-material',
              component: () => import('@/views/pages/supplier-manage/SupplierDetailsGeneral/manage-raw-materials/ManufactureDetailsView.vue'),
              meta: {
                parent: 'manage-raw-materials',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Raw materials', url: '/pages/raw-materials' },
                  { title: 'Raw Material View', active: true }
                ],
                pageTitle: 'View Raw Material',
                rule: 'editor'
              }
            },
            {
              path: 'orders/:id',
              name: 'manage-raw-material-order',
              component: () => import('@/views/pages/raw-material/rm-orders/RmOrderDetailsView.vue'),
              meta: {
                parent: 'manage-raw-materials',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Raw materials', active: true }
                ],
                pageTitle: 'RM Orders Details',
                rule: 'editor'
              }
            }
          ],
        },
        {
          path: '/pages/sundry-items',
          component: () => import('@/views/pages/sundry-items/SundryItemsHome.vue'),
          children: [
            {
              path: '',
              component: () => import('@/views/pages/sundry-items/SundryItemsTabView.vue'),
              name: 'manage-sundry-items',
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Sundry Items', active: true }
                ],
                pageTitle: 'Manage Sundry Items',
                rule: 'editor'
              }
            },
            {
              path: 'orders/:id',
              name: 'manage-sundry-item-order',
              component: () => import('@/views/pages/sundry-items/item-orders/SundryItemOrderDetailsView.vue'),
              meta: {
                parent: 'manage-sundry-items',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Sundry Item Orders', active: true }
                ],
                pageTitle: 'Sundry Item Orders',
                rule: 'editor'
              }
            }
          ]
        },
        {
          path: '/pages/other-supplier-service',
          component: () => import('@/views/pages/other-services/OtherServicesHome.vue'),
          name: 'other-services',
          children: [
            {
              path: '',
              component: () => import('@/views/pages/other-services/OtherServicesTabView'),
              name: 'other-services-tab',
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Other services', active: true }
                ],
                pageTitle: 'Manage Other Services',
                rule: 'editor'
              }
            },
          ]
        },
        {
          path: '/pages/other-supplier-service/orders/:id',
          component: () => import('@/views/pages/supplier-manage/other-suppliers/sundry-supplier-tabs/service-orders/OtherSupplierOrderView'),
          name: 'other-services-view',
          meta: {
            parent: 'other-service',
            breadcrumb: [
              { title: 'Home', url: '/'},
              { title: 'Other Service Order', active: true}
            ],
            pageTitle: 'Service Order Details'
          },
        },
        {
          path: '/pages/stock-check',
          name: 'stock-check',
          component: () => import('@/views/pages/stock-checks/StockChecksHome.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Stock Details', active: true }
            ],
            pageTitle: 'Manage Stock',
            rule: 'editor'
          }
        },
        {
          path: '/pages/stock-report',
          name: 'stock-report',
          component: () => import('@/views/pages/stock-reports/StockReportHome.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'SSL Stock Report', active: true }
            ],
            pageTitle: 'SSL Stock Report',
            rule: 'editor'
          }
        },
        {
          path: '/pages/project-brief',
          name: 'manage-project-brief',
          component: () => import('@/views/pages/project-briefs/ProjectBriefList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Project Brief', active: true }
            ],
            pageTitle: 'Manage Project Brief',
            rule: 'editor'
          }
        },
        {
          path: '/pages/sample-orders',
          name: 'manage-sample-orders',
          component: () => import('@/views/pages/customer-manage/CustomerDetailsGeneral/samples/sample-orders/CustomerSampleOrdersList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Sample Orders', active: true }
            ],
            pageTitle: 'Manage Sample Orders',
            rule: 'editor'
          }
        },
        {
          path: '/pages/sample-orders/:id',
          name: 'sample-orders-details-view',
          component: () => import('@/views/pages/sample-orders/SampleOrderDetailsView.vue'),
          meta: {
            parent: 'manage-sample-orders',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Sample Order View', active: true }
            ],
            pageTitle: 'Sample Order View',
            rule: 'editor'
          }
        },
        {
          path: '/pages/sales-quote',
          name: 'manage-sales-quote',
            component: () => import('@/views/pages/sales-quote/SalesQuoteList.vue'),
          meta: {
            parent: 'manage-sales-quote',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Sales Quotes', active: true }
            ],
            pageTitle: 'Manage Sales Quote',
            rule: 'editor'
          }
        },
        {
          path: '/pages/sales-quote/:id/update',
          name: 'manage-sales-quote-update',
            component: () => import('@/views/pages/sales-quote/UpdateSalesQuote.vue'),
          meta: {
            parent: 'manage-sales-quote',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Sales Quotes Update', active: true }
            ],
            pageTitle: 'Sales Quotes Update',
            rule: 'editor'
          }
        },
        {
          path: '/pages/product-orders',
          name: 'manage-product-orders',
          // component: () => import('@/views/pages/product-orders/CustomerProductOrdersList.vue'),
          component: () => import('@/views/pages/customer-manage/CustomerDetailsGeneral/product-orders/CustomerProductOrdersList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Customer Orders', active: true }
            ],
            pageTitle: 'Manage Customer Orders',
            rule: 'editor'
          }
        },
        {
          path: '/pages/product-orders/:id',
          name: 'product-order-details-view',
          // component: () => import('@/views/pages/product-orders/ProductOrderDetailsView.vue'),
          component: () => import('@/views/pages/customer-manage/CustomerDetailsGeneral/product-orders/ProductOrderDetailsView.vue'),
          meta: {
            parent: 'manage-product-orders',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Customer Orders', url: '/pages/product-orders' },
              { title: 'Order View', active: true }
            ],
            pageTitle: 'Product Order View',
            rule: 'editor'
          }
        },
        {
          path: '/pages/courier-shipments',
          name: 'courier-shipment',
          component: () => import('@/views/pages/supplier-manage/couriers/courier-supplier-tabs/CourierSupplierShipmenList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Goods out & Logistics', active: true }
            ],
            pageTitle: 'Courier Shipments',
            rule: 'editor'
          }
        },
        {
          path: '/pages/invoices',
          name: 'invoices',
          component: () => import('@/views/pages/invoices/InvoiceList.vue')
        },
        {
          path: '/pages/invoices/:id',
          name: 'invoice-view',
          component: () => import('@/views/pages/invoices/SalesInvoiceView.vue'),
          meta: {
            parent: 'invoices',
          },
        },
        {
          path: '/pages/credit-notes',
          name: 'credit-notes',
          component: () => import('@/views/pages/credit-notes/CreditNoteList.vue')
        },
        {
          path: '/pages/outstanding-orders',
          name: 'outstanding-orders',
          component: () => import('@/views/pages/reporting-graph/OutstandingOrderList.vue')
        },
        {
          path: '/pages/otif-report',
          name: 'otif-report',
          component: () => import('@/views/pages/reporting-graph/OtifReport.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Sales & Marketing', url: '/pages/product-orders' },
              { title: 'OTIF Report', active: true },
            ],
            pageTitle: 'OTIF Report',
            rule: 'editor'
          }
        },
        {
          path: '/pages/forecasts',
          name: 'Forecast Tool',
          component: () => import('@/views/pages/forecast-tool/ForecastList')
        },
        {
          path: '/pages/budget-tool',
          name: 'Forecast Tool',
          component: () => import('@/views/pages/budget-tool/BudgetToolList')
        },
        {
          path: '/pages/settings',
          name: 'settings',
          component: () => import('@/views/pages/settings/SettingsHome.vue')
        },
        {
          path: '/pages/settings/templates/:id',
          name: 'settings',
          component: () => import('@/views/pages/settings/General/ScheduledTasks/templateView.vue'),
          meta: {
          breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Settings', active: true, url:"/pages/settings" },
              { title: 'Templates', active: true, url:"/pages/settings?tab=staff+scheduled_task_templates"},
              { title: 'Template', active: true, url:"pages/settings" }
          ],
          pageTitle:'Templates',
          rule: 'editor'
        }
        },
        ,
        {
          path: '/pages/scheduled-tasks',
          name: 'scheduled-tasks',
          component: () => import('@/views/pages/scheduled-tasks/tasks.vue'),
          meta: {
          breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Tasks', active: true, url:"/pages/scheduled-tasks"},

          ],
          pageTitle:'Scheduled Tasks',
          rule: 'editor'
        }
      },
        {
          path: '/pages/scheduled-tasks/:id',
          name: 'scheduled-tasks-view',
          component: () => import('@/views/pages/scheduled-tasks/taskView.vue'),
          meta: {
          breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Tasks', active: true, url:"/pages/scheduled-tasks"},
              { title: 'Task', active: true, url:"pages/scheduled-tasks/" }
          ],
          pageTitle:'Scheduled Task View',
          rule: 'editor',
          parent: 'scheduled-tasks',
        }
        },
        {
          path: '/pages/task-instance',
          name: 'scheduled-tasks-instance',
          component: () => import('@/views/pages/scheduled-tasks/taskInstance.vue'),
          meta: {
          breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Tasks', active: true, url:"/pages/task-instance"},

          ],
          pageTitle:'Active Tasks',
          rule: 'editor'
        }
      },
      {
          path: '/pages/archived-tasks',
          name: 'archived-tasks-list',
          component: () => import('@/views/pages/scheduled-tasks/archivedTaskList.vue'),
          meta: {
          pageTitle:'Archived Tasks',
          rule: 'editor'
        }
      },
        {
          path: '/pages/task-instance/:id',
          name: 'scheduled-tasks-instance-view',
          component: () => import('@/views/pages/scheduled-tasks/taskInstanceView.vue'),
          meta: {
          breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Tasks', active: true, url:"/pages/task-instance/"},
              { title: 'Task', active: true, url:"pages/task-instance/" }
          ],
          pageTitle:'Scheduled Task View',
          rule: 'editor',
          parent: 'task-instance',
        }
        },
        {
          path: '/pages/edit-parameters',
          name: 'edit-parameters',
          component: () => import('@/views/pages/edit-parameters/ParametersHome.vue')
        },
        {
          path: '/pages/activity-logs',
          name: 'activity-logs',
          component: () => import('@/views/pages/logs/LogHome.vue'),
          children: [
            {
              path: '',
              name: 'activity-log-tab-details',
              component: () => import('@/views/pages/logs/LogTabDetails.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                ],
                parent: 'activity-logs',
                pageTitle: 'ACTIVITY LOG',
              }
            },
            {
              path: 'rm-stock-adjust/:id/rm-batch',
              name: 'rm-stock-adjust-batch',
              component: () => import('@/views/pages/logs/stock-adjust/raw-materials/RawMaterialBatchList.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Raw Material List', url: '/pages/activity-logs' },
                  { title: 'RM Batch List', active: true }
                ],
                parent: 'activity-logs',
                pageTitle: 'RM STOCK ADJUST BATCH',
              }
            },
            {
              path: 'fg-stock-adjust/:id/fg-batch',
              name: 'fg-stock-adjust-batch',
              component: () => import('@/views/pages/logs/stock-adjust/formulations/FinishedProductBatchList.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'FG List', url: '/pages/activity-logs?step=2' },
                  { title: 'FG Batch List', active: true }
                ],
                parent: 'activity-logs',
                pageTitle: 'FG STOCK ADJUST BATCH',
              }
            },
            {
              path: 'sundry-stock-adjust/:id/sundry-batch',
              name: 'sundry-stock-adjust-batch',
              component: () => import('@/views/pages/logs/stock-adjust/sundry-items/SundryItemBatchList.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Sundry Item List', url: '/pages/activity-logs?step=4' },
                  { title: 'Sundry Item Batch List', active: true }
                ],
                parent: 'activity-logs',
                pageTitle: 'SUNDRY ITEM STOCK ADJUST BATCH',
              }
            },
          ]
        },
        {
          path: '/pages/sage-verification',
          name: 'sage-verification',
          component: () => import('@/views/pages/sage/SageConfirmPermission.vue')
        },
        {
          path: '/pages/manufacturing',
          component: () => import('@/views/pages/manufacturing/work-orders/WorkOrderHome.vue'),
          children: [
            {
              path: 'production-line',
              name: 'production-line',
              component: () => import('@/views/pages/manufacturing/production-line/ProductionLineList.vue'),
            },
            {
              path: 'manufacturing-timeline',
              name: 'manufacturing-timeline',
              component: () => import('@/views/pages/manufacturing/work-orders/Test.vue')
            },
            {
              path: 'allocate-from-stock',
              name: 'allocate-from-stock',
              component: () => import('@/views/pages/manufacturing/allocate-stock/AllocateFromStockToOrder.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Work Orders', url: '/pages/manufacturing/work-orders' },
                  { title: 'Allocate From Stock', active: true }
                ],
                parent: 'work-orders',
                pageTitle: 'FG Allocate from Stock',
              }
            },
            {
              path: 'work-orders',
              name: 'work-orders',
              component: () => import('@/views/pages/manufacturing/work-orders/WorkOrderList.vue')
            },
            {
              path: 'work-orders/create',
              name: 'work-orders-create',
              component: () => import('@/views/pages/manufacturing/work-orders/WorkOrderCreate.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Work Orders', url: '/pages/manufacturing/work-orders' },
                  { title: 'Create', active: true }
                ],
                parent: 'work-orders',
                pageTitle: 'Work Order Create',
              }
            },
            {
              path: 'work-orders/create-stock',
              name: 'work-orders/create-stock',
              component: () => import('@/views/pages/manufacturing/work-orders/wo-create/WorkOrderCreateForStock.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Work Orders', url: '/pages/manufacturing/work-orders' },
                  { title: 'Create', active: true }
                ],
                parent: 'work-orders',
                pageTitle: 'Work Order Create for Stock',
              }
            },
            {
              path: 'work-orders/:id/details',
              name: 'work-order-details',
              component: () => import('@/views/pages/manufacturing/work-orders/WorkOrderView.vue'),
              meta: {
                    breadcrumb: [
                      { title: 'Home', url: '/' },
                      { title: 'Work Orders', url: '/pages/manufacturing/work-orders' },
                      { title: 'Details', active: true }
                    ],
                parent: 'work-orders',
                pageTitle: 'Work Order Details',
              }
            },
            {
              path: 'formulation-stock',
              name: 'formulation-stock',
              component: () => import('@/views/pages/manufacturing/formulation-stock/FormulationStockInventory.vue'),
              meta: {
                pageTitle: 'Formulation Stock Inventory',
              }
            },
            {
              path: 'raw-material-stock',
              name: 'raw-material-stock',
              component: () => import('@/views/pages/manufacturing/raw-material-stock/RawMaterialStockInventory.vue'),
              meta: {
                pageTitle: 'Raw Material Stock Inventory',
              }
            },
            {
              path: 'raw-material-stock/create',
              name: 'raw-material-stock-create',
              component: () => import('@/views/pages/manufacturing/raw-material-stock/RMOrdersList.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Manage Stock', url: '/pages/stock-check' },
                  { title: 'Create', active: true }
                ],
                parent: 'stock-check',
                pageTitle: 'Create Raw Material Stock Inventory',
              }
            },
          ]
        },
        {
          path: '/pages/po-invoices',
          name: 'grni-report',
          component: () => import('@/views/pages/financial-manage/GrniList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/', active: true },
            ],
            pageTitle: 'PURCHASE ORDER INVOICES',
            rule: 'editor'
          }
        },
        {
          path: '/pages/so-invoices',
          name: 'manage-invoices',
          component: () => import('@/views/pages/invoices/InvoiceList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/', active: true },
            ],
            pageTitle: 'SALES ORDER INVOICES',
            rule: 'editor'
          }
        },
        {
          path: '/pages/credit-limit-requests',
          name: 'credit-limit-report',
          component: () => import('@/views/pages/financial-manage/CreditLimitRequestList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/', active: true },
            ],
            pageTitle: 'CUSTOMER CREDIT REPORT',
            rule: 'editor'
          }
        },
        {
          path: '/pages/crm',
          component: () => import('@/views/pages/crm-tool/CrmHome.vue'),
          children: [
            {
              path: 'merged-fields',
              name: 'merged-fields',
              component: () => import('@/views/pages/crm-tool/settings/MergedFieldList.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/', active: true },
                ],
                pageTitle: 'CRM FIELDS',
                rule: 'editor'
              }
            },
            {
              path: 'marketing-leads',
              name: 'marketing-leads',
              component: () => import('@/views/pages/crm-tool/audience-manage/MartketingLeadList.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/', active: true },
                ],
                pageTitle: 'NEW ENQUIRIES',
                rule: 'editor'
              }
            },
            {
              path: 'marketing-leads/:id',
              name: 'marketing-leads-member-details',
              component: () => import('@/views/pages/crm-tool/audience-manage/members/MemberHome.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'New Enquiries', url: '/pages/crm/marketing-leads' },
                  { title: 'Details', active: true }
                ],
                parent: 'marketing-leads',
                pageTitle: 'NEW ENQUIRIES',
                rule: 'editor'
              },
            },
            {
              path: 'marketing-leads-suspect',
              name: 'marketing-leads-suspect',
              component: () => import('@/views/pages/crm-tool/audience-manage/marketing-leads/SuspectMartketingLeadList.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/', active: true },
                ],
                pageTitle: 'LEADS',
                rule: 'editor'
              }
            },
            {
              path: 'marketing-leads-suspect/:id',
              name: 'marketing-leads-suspect-member-details',
              component: () => import('@/views/pages/crm-tool/audience-manage/members/MemberHome.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Leads', url: '/pages/crm/marketing-leads-suspect' },
                  { title: 'Details', active: true }
                ],
                parent: 'marketing-leads-suspect',
                pageTitle: 'LEADS',
                rule: 'editor'
              },
            },
            {
              path: 'marketing-leads-opportunities',
              name: 'marketing-leads-opportunities',
              component: () => import('@/views/pages/crm-tool/audience-manage/marketing-leads/OpportunitiesMartketingLeadList.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/', active: true },
                ],
                pageTitle: 'OPPORTUNITIES',
                rule: 'editor'
              }
            },
            {
              path: 'marketing-leads-opportunities/:id',
              name: 'marketing-leads-opportunities-member-details',
              component: () => import('@/views/pages/crm-tool/audience-manage/members/MemberHome.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Opportunities', url: '/pages/crm/marketing-leads-opportunities' },
                  { title: 'Details', active: true }
                ],
                parent: 'marketing-leads-opportunities',
                pageTitle: 'OPPORTUNITIES',
                rule: 'editor'
              },
            },
            {
              path: 'marketing-leads-influence',
              name: 'marketing-leads-influence',
              component: () => import('@/views/pages/crm-tool/audience-manage/marketing-leads/InfluenceMartketingLeadList.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/', active: true },
                ],
                pageTitle: 'SUBSCRIBERS',
                rule: 'editor'
              }
            },
            {
              path: 'marketing-leads-influence/:id',
              name: 'marketing-leads-influence-member-details',
              component: () => import('@/views/pages/crm-tool/audience-manage/members/MemberHome.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Subscribers', url: '/pages/crm/marketing-leads-influence' },
                  { title: 'Details', active: true }
                ],
                parent: 'marketing-leads-influence',
                pageTitle: 'SUBSCRIBERS',
                rule: 'editor'
              },
            },
            {
              path: 'marketing-leads-closed',
              name: 'marketing-leads-closed',
              component: () => import('@/views/pages/crm-tool/audience-manage/marketing-leads/ClosedNIOList.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/', active: true },
                ],
                pageTitle: 'CLOSED',
                rule: 'editor'
              }
            },
            {
              path: 'marketing-leads-closed/:id',
              name: 'marketing-leads-closed-member-details',
              component: () => import('@/views/pages/crm-tool/audience-manage/members/MemberHome.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Closed', url: '/pages/crm/marketing-leads-closed' },
                  { title: 'Details', active: true }
                ],
                parent: 'marketing-leads-closed',
                pageTitle: 'CLOSED',
                rule: 'editor'
              },
            },
            {
              path: 'account-owner-summary',
              name: 'account-owner-summary',
              component: () => import('@/views/pages/crm-tool/audience-manage/marketing-leads/AccountOwnerSummaryLeadList.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/', active: true },
                ],
                pageTitle: 'CRM SUMMARY',
                rule: 'editor'
              }
            },
            {
              path: 'marketing-leads-indirect-channel',
              name: 'marketing-leads-indirect-channel',
              component: () => import('@/views/pages/crm-tool/audience-manage/marketing-leads/IndirectChannelMartketingLeadList.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/', active: true },
                ],
                pageTitle: 'INDIRECT CHANNEL',
                rule: 'editor'
              }
            },
            {
              path: 'aggregated-activity',
              name: 'aggregated-activity',
              component: () => import('@/views/pages/crm-tool/aggregated-activity/CrmAggregatedActivityHome.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Aggregated Activity', active: true }
                ],
                pageTitle: 'CRM AGGREGATED ACTIVITY',
                rule: 'editor'
              },
            },
          ],
        },
        {
          path: '/pages/my-schedule',
          name: 'my-schedule',
          component: () => import('@/views/pages/my-schedule/MySheduleMain.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/', active: true },
            ],
            pageTitle: 'SCHEDULE',
            rule: 'editor'
          }
        },
        {
          path: '/pages/cms-builder/:template_id',
          name: 'cms-builder',
          component: () => import('@/views/pages/crm-builder/CrmBuilderMain.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/', active: true },
            ],
            parent: 'settings',
            pageTitle: 'CMS BUILDER',
            rule: 'editor'
          }
        },
        // {
        //   path: '/pages/manage-nimble/manufacturing/:id',
        //   name: 'manage-nimble',
        //   component: () => import('@/views/pages/supplier-manage/SupplierDetailsGeneral/manage-manufacturing/ManufactureDetailsView.vue'),
        //   meta: {
        //     breadcrumb: [
        //       { title: 'Home', url: '/' },
        //       { title: 'Pages' },
        //       { title: 'Suppliers' },
        //       { title: 'Suppliers Manufacturing', active: true }
        //     ],
        //     pageTitle: 'Manage Manufacturing',
        //     rule: 'editor'
        //   }
        // },
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      beforeEnter: AutoLogin,
      children: [
        {
          path: '/pages/manufacturing/work-orders/:id/print-view',
          name: 'work-order-print-view',
          component: () => import('@/views/pages/manufacturing/work-orders/print-view/WorkOrderPrintView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Work Orders', url: '/pages/manufacturing/work-orders' },
              { title: 'Print View', active: true }
            ],
            parent: 'work-orders',
            pageTitle: 'Work Order Print View',
          }
        },
        {
          path: '/pages/formulations/:id/print-view',
          name: 'formulation-print-view',
          component: () => import('@/views/pages/formulations/print-view/FormulationPrintView.vue'),
          meta: {
            parent: 'manage-formulation',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Formulations & NPD', url: '/pages/formulations'},
              { title: 'Print View', active: true }
            ],
            pageTitle: 'Print Formulations',
            rule: 'editor'
          }
        },
        {
          path: '/pages/sample-orders/:id/print-view',
          name: 'sample-orders-print-view',
          component: () => import('@/views/pages/sample-orders/SampleOrderPrintView.vue'),
          meta: {
            parent: 'manage-sample-orders',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Sample Order Print View', active: true }
            ],
            pageTitle: 'Sample Order Print View',
            rule: 'editor'
          }
        },
        {
          path: '/pages/sample-orders/:id/label-print-view',
          name: 'sample-orders-item-label-print-view',
          component: () => import('@/views/pages/sample-orders/sampleOrderItemLabelPrintView.vue'),
          meta: {
            parent: 'manage-sample-orders',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Sample Order Item Label Print View', active: true }
            ],
            pageTitle: 'Sample Order Item Label Print View',
            rule: 'editor'
          }
        },
        {
          path: '/pages/raw-materials/orders/:id/print-view',
          name: 'rm-orders-print-view',
          component: () => import('@/views/pages/raw-material/rm-orders/RmOrdersPrintView'),
          meta: {
            parent: 'manage-raw-materials',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'RM Order Print View', active: true }
            ],
            pageTitle: 'RM Order Print View',
            rule: 'editor'
          }
        },
        {
          path: '/pages/sales-quote/:id/print-view',
          name: 'sales-quote-print-view',
          component: () => import('@/views/pages/sales-quote/SalesQuotePrintView'),
          meta: {
            parent: 'manage-sales-quote',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Sales Quotes', active: true }
            ],
            pageTitle: 'Sales Quote Print View',
            rule: 'editor'
          }
        },
        {
          path: '/pages/manage-nimble/customers/credit-note/:secret_code/:id/print-view',
          name: 'credit-note-print-view',
          component: () => import('@/views/pages/customer-manage/CustomerDetailsGeneral/CustomerCreditNotePrintView.vue'),
          meta: {
            parent: 'manage-customers',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Customer Details', active: true }
            ],
            pageTitle: 'Credit Note Print View',
            rule: 'editor'
          }
        },
        {
          path: '/pages/project-brief/:id/print-view',
          name: 'project-brief-print-view',
          component: () => import('@/views/pages/project-briefs/ProjectBriefPrintView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Project Briefs', active: true }
            ],
            pageTitle: 'Project Brief Print View',
            rule: 'editor'
          }
        },
        {
          path: '/pages/sundry-items/orders/:id/print-view',
          name: 'sundry-item-order-print-view',
          component: () => import('@/views/pages/sundry-items/item-orders/SundryItemOrderPrintView.vue'),
          meta: {
            parent: 'manage-sundry-items',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Sundry Orders', active: true }
            ],
            pageTitle: 'Sundry Order Print View',
            rule: 'editor'
          }
        },
        {
          path: '/pages/other-supplier-service/orders/:id/print-view',
          name: 'other-supplier-service-order-print-view',
          component: () => import('@/views/pages/supplier-manage/other-suppliers/sundry-supplier-tabs/service-orders/OtherServiceOrderPrintView.vue'),
          meta: {
            parent: 'other-services-order-view',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Other Service Orders', active: true }
            ],
            pageTitle: 'Other Service Order Print View',
            rule: 'editor'
          }
        },
        {
          path: 'pages/manufacturing/work-orders/label/:id/print-view',
          name: 'work-order-label-print-view',
          component: () => import('@/views/pages/manufacturing/work-orders/WoLabelPrintView.vue'),
          meta: {
            parent: 'work-orders',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Work Orders', url: '/pages/manufacturing/work-orders' },
              { title: 'Print View', active: true }
            ],
            pageTitle: 'WO Label Print View',
          }
        },
        {
          path: '/pages/support-app-auth',
          name: 'support-app-auth',
          component: () => import('@/views/pages/SupportAppAuth.vue'),
          meta: {
            pageTitle: 'Support App Auth',
          }
        },
      ],
    },
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      redirect: '/page/login',
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue'),
          beforeEnter: AutoLogin,
        },
        {
          path: '/pages/test',
          name: 'page-test',
          component: () => import('@/views/Page2.vue')
        },
        {
          path: '/files/invoice/:key',
          name: 'public-invoice',
          component: () => import('@/views/pages/public/Invoice.vue')
        },
        {
          path: '/files/delivery-note/:key',
          name: 'public-delivery-note',
          component: () => import('@/views/pages/public/DeliveryNote.vue')
        },
        {
          path: '/files/confirmation_order/:key',
          name: 'public-confirmation',
          component: () => import('@/views/pages/public/OrderConfirmation.vue')
        },
        {
          path: '/files/sundry_order/:key',
          name: 'public-sundry-order-confirmation',
          component: () => import('@/views/pages/public/SundryOrderConfirmation.vue')
        },
        {
          path: '/files/other_order/:key',
          name: 'public-other-order-confirmation',
          component: () => import('@/views/pages/public/OtherOrderConfirmation.vue')
        },
        {
          path: '/files/confirmation_rm_order/:key',
          name: 'public-rm-order-confirmation',
          component: () => import('@/views/pages/public/RmOrdersConfirmation.vue')
        },
        {
          path: '/files/sales-quote/:key',
          name: 'public-sales-quote',
          component: () => import('@/views/pages/public/SalesQuote.vue')
        },
        {
          path: '/files/credit_note/:key',
          name: 'public-credit-note',
          component: () => import('@/views/pages/public/CreditNote.vue')
        },
        {
          path: '/files/work_order/:key',
          name: 'public-work-order',
          component: () => import('@/views/pages/public/WorkOrder.vue')
        },
        {
          path: '/files/work_order_list',
          name: 'public-work-order-list',
          component: () => import('@/views/pages/public/WorkOrderList.vue')
        },
        {
          path: '/pages/email-verification/:code',
          name: 'page-verification',
          component: () => import('@/views/pages/EmailVerification.vue')
        },
        {
          path: '/pages/email-change/:token',
          name: 'page-email-change',
          component: () => import('@/views/pages/EmailChangeConfirm.vue')
        },
        {
          path: '/pages/forgot-password',
          name: 'page-forgot-password',
          component: () => import('@/views/pages/ForgotPassword.vue')
        },
        {
          path: '/pages/reset-password/:token',
          name: 'page-reset-password',
          component: () => import('@/views/pages/ResetPassword.vue')
        },
        {
          path: '/pages/supplier',
          name: 'page-supplier',
          component: () => import('@/views/pages/supplier-manage/SupplierRegister.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
        {
          path: '/doc/:code',
          name: 'invoice-redirect-page',
          component: () => import('@/views/pages/InvoiceRedirectPage.vue')
        },
        {
          path: '/files/sample-invoice/:key',
          name: 'public-sample--invoice',
          component: () => import('@/views/pages/public/SampleInvoice.vue')
        },
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }

  const activePopups = document.querySelectorAll('.con-vs-popup')
  activePopups.forEach((popup) => {
    popup.style.display = 'none'
  })

  const activeDialogs = document.querySelectorAll('.con-vs-dialog')
  activeDialogs.forEach((dialog) => {
    dialog.style.display = 'none'
  })
})


export default router
